import React from 'react';

/**
 * A simple, professional react, bootstrap component which will fill all space horizontally and vertically
 * and align its child contents centered both horizontally and vertically.
 */
const CenteredContent = ({ children }) => {
  return (
    <div className="border container vh-100" style={{ minWidth: 'unset' }}>
      <div
        className="row h-100 justify-content-center align-items-center"
        style={{ minWidth: 'unset' }}
      >
        {children}
      </div>
    </div>
  );
};

export default CenteredContent;
